<template>
  <v-layout wrap justify-space-between pb-2 pt-2 class="text-sm-left"
            v-if="ratePlan !== undefined && room.maxOccupancy > 1">
    <v-flex xs12>
      <v-select v-model="ratePlan.paymentType"
                :items="paymentTypes"
                item-text="label"
                item-value="value"
                :label="$t('hotel.kognitiv.occupancySettingsSelect')"
                required
                :hint="$t('hotel.kognitiv.occupancySettingsHint')"
                persistent-hint
                :rules="rules"/>
    </v-flex>
    <v-flex xs12>
      <v-alert :value="ratePlan.paymentType === undefined" color="error" outlined>
        {{$t('hotel.kognitiv.occupancySettingsNotDefinedYet')}}
      </v-alert>
    </v-flex>
    <v-flex xs12 class="text-sm-center" v-if="ratePlan.paymentType === 'CUSTOM'">
      <v-card flat style="background-color: transparent;">
        <v-card-title style="padding: 0;">
          <v-layout wrap>
            <v-flex xs12 mt-3 mb-1>
              <v-icon medium color="primary">arrow_downward</v-icon>
            </v-flex>
            <v-flex xs3>
              <v-select
                v-model="ratePlan.paymentMode"
                :items="paymentModes"
                item-text="label"
                item-value="value"
                :label="$t('hotel.kognitiv.paymentSettingsSelect')"
                required
                :rules="rules"></v-select>
            </v-flex>
            <v-flex xs8 offset-xs1>
              <v-text-field
                v-model="ratePlan.payment"
                :rules="rules"
                type="number"
                :label="$t('hotel.kognitiv.paymentValue')"
                :hint="$t('hotel.kognitiv.paymentSettingsHint')"
                persistent-hint
                required></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-title>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    name: 'OccupancyPaymentRule',
    props: {
      ratePlan: undefined,
      room: undefined,
    },
    data() {
      return {
        paymentTypes: [
          { value: 'FULLPRICE', label: this.$i18n.t('hotel.kognitiv.fullPrice') },
          { value: 'CUSTOM', label: this.$i18n.t('hotel.kognitiv.custom') }
        ],
        paymentModes: [
          { value: 'PERCENT', label: this.$i18n.t('season.percentage') },
          { value: 'EURO', label: 'Euro' }
        ],
        rules: [
          v => !!v || this.$i18n.t('form.required'),
        ],
      };
    }
  };
</script>
